import { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import icoback from '../img/ico-back.svg';
import icobackblue from '../img/ico-backblue.svg';
import icosearch from '../img/ico-search.svg';
import icoclose from '../img/ico-close.svg';
import strings from '../strings.js'
import SongCard from '../SongCard';
import SelectingYesNoCard from '../SelectingYesNoCard';
import heart from '../img/heart.svg';
import noheart from '../img/noheart.svg';
import { SendMessage } from '../App.js';
import useNewsSearch from '../useNewsSearch';

const API_URL = "https://www.starboxkod.com/api";

const song1 = {
    "song_num": 110108,
    "song_name": "给我多一点",
    "singer": "SHE",
    "language": "国语",
    "server_id": "C",
    "rel_path": "05\\110108"
}



export function New({cookieFavs, setCookieFavs, stateVer, lang, selectingYesNo, tableNo,  setSelectedSinger}) {

    const [searchTerm, setSearchTerm] = useState("");
    const [pageNumber, setPageNumber] = useState(0);
    const [searchLang, setSearchLang] = useState("language")

      const langOptions = [
    { id: "language", labelKey: "songall" }, // "language" uses the "songall" string
    { id: "国语", labelKey: "国语" },
    { id: "粤语", labelKey: "粤语" },
    { id: "台语", labelKey: "台语" },
    { id: "潮语", labelKey: "潮语" },
    { id: "英语", labelKey: "英语" },
    { id: "马来", labelKey: "马来" },
    { id: "日语", labelKey: "日语" },
    { id: "韩语", labelKey: "韩语" },
    { id: "泰语", labelKey: "泰语" },
    { id: "印度语", labelKey: "印度语" },
    { id: "越南语", labelKey: "越南语" },
    { id: "菲律宾语", labelKey: "菲律宾语" },
    { id: "other", labelKey: "other" },
    ];


    const LANGUAGE_MAP = {
    2: "国语",
    7: "粤语",
    5: "台语",
    15: "潮语",
    6: "英语",
    9: "马来",
    4: "日语",
    3: "韩语",
    10: "泰语",
    13: "印度语",
    12: "越南语",
    14: "菲律宾语",
    8: "other"
    };

    const [blockedLangs, setBlockedLangs] = useState(() => {
        const item = localStorage.getItem("black");
        if (!item) return [];

        try {
            const parsed = JSON.parse(item);
            const langIds = parsed?.language ?? [];

            // Map each ID to its language name; fall back to the ID string if missing
            return langIds.map(id => LANGUAGE_MAP[id] ?? String(id));
        } catch (error) {
            console.error("Failed to parse local storage key 'black'", error);
            return [];
        }
    });
    
    const {
        loading,
        error,
        songs,
        hasMore
    } = useNewsSearch(searchTerm, pageNumber, searchLang, blockedLangs)

    const observer = useRef()
    const lastSongElementRef = useCallback(node => {
        if (loading) return
        if (observer.current) observer.current.disconnect()
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                setPageNumber(prevPageNumber => prevPageNumber + 20)
            }
        })
        if (node) observer.current.observe(node)
    }, [loading, hasMore])
    
    function handleSearch(e) {
        setSearchTerm(e.target.value)
        setPageNumber(0)
    }
    
    useEffect(() => {
        setPageNumber(0)
        document.getElementById("song-container").scrollTop =0;
      }, [searchTerm, searchLang])

    const [selectingYadsdasesNo, setSelectingYesNo] = useState(false);
    const [selectingYesNoSong, setSelectingYesNoSong] = useState({});
    function nowSelectSong ({ song }) {
        navigate("/home/new/select");
        setSelectingYesNoSong(song);
    }

    

    
    const navigate = useNavigate()

    return (<>
    <div className="purpleHeader26" style={{marginTop:'0'}}>
    <div className="heatder" style={{backgroundImage:'none'}}>
        <a onClick={(e) => {e.preventDefault(); navigate(-1)}}>
        <img
            src={icoback}
            alt="home"
        />
        </a>
        <div className = "headerReplaceText">{lang ? strings.cn.newsong : strings.en.newsong}</div>
        <div className = "headerEndText">{/* {songs.length} */}</div>
    </div>
    <div className="language-bar-container" style={{marginTop:'62px', paddingTop:'calc(4.5rem - 62px)'}}>
        <div className="language-bar">
                            {langOptions.map((option) => {
                                // Skip rendering if the language is in the blockedLangs array 
                                // (Note: your original code didn't block "language", so we ensure it always renders)
                                if (option.id !== "language" && blockedLangs.includes(option.id)) {
                                return null;
                                }

                                return (
                                <div
                                    key={option.id}
                                    className={`pill-btn ${searchLang === option.id ? "selected" : ""}`}
                                    onClick={(e) => {
                                    e.preventDefault();
                                    setSearchLang(option.id);
                                    }}
                                >
                                    {lang ? strings.cn[option.labelKey] : strings.en[option.labelKey]}
                                </div>
                                );
                            })}
        </div>
    </div>
    </div>

    <div className="song-container" id="song-container">
    {songs?.length > 0
        ? (
            <>
                {songs.map((song, index) => {
                    if (songs.length == index + 1) {
                        return <SongCard setSelectedSinger={setSelectedSinger} innerRef={lastSongElementRef} song={song} key={song.song_num} lang={lang} onClick={() => { nowSelectSong({song});}}/>
                    } else {
                        return <SongCard setSelectedSinger={setSelectedSinger} song={song} key={song.song_num} lang={lang} onClick={() => { nowSelectSong({song});}}/>
                    }
                    
                })}     
            </>
        ) :
        (
            <div className="empty">
                <h2>No songs found</h2>
            </div>
        )}
    </div>

    {loading && 'Loading...'}
    {error && 'Error...'}

    { selectingYesNo && (
        <>
        <SelectingYesNoCard cookieFavs={cookieFavs} setCookieFavs={setCookieFavs} song={selectingYesNoSong} onClick={() => { setSelectingYesNo(false); navigate(-1);}} stateVer={stateVer} lang={lang} tableNo={tableNo}/>
        </>
    )}
    
</>)}
